import type { CHECK_FEATURE_ACCESS_HEADER_NAME } from "@src/auth/permissions/usePreRequestFeatureAccessCheck";
import { useFeatureFlag } from "@src/backpack-console/featureFlags";
import { useMemo } from "react";

export const EQUIPMENT_SPECS_READS_HEADER_NAME =
  "X-Enable-Equipment-Specs-Reads";
export const EQUIPMENT_SPECS_WRITES_HEADER_NAME =
  "X-Enable-Equipment-Specs-Writes";

type Empty = Partial<Record<PropertyKey, never>>;

export type EquipmentSpecsReadHeaders =
  | { [EQUIPMENT_SPECS_READS_HEADER_NAME]: string }
  | Empty;

export type EquipmentSpecsWriteHeaders =
  | {
      [EQUIPMENT_SPECS_READS_HEADER_NAME]: string;
      [EQUIPMENT_SPECS_WRITES_HEADER_NAME]: string;
    }
  | Empty;

export type EquipmentRequestHeaders = Partial<
  Record<
    | typeof CHECK_FEATURE_ACCESS_HEADER_NAME
    | typeof EQUIPMENT_SPECS_READS_HEADER_NAME
    | typeof EQUIPMENT_SPECS_WRITES_HEADER_NAME,
    string
  >
>;

export function useEquipmentSpecsRolloutEnabled() {
  return useFeatureFlag("eliminate-two-way-sync", "off") === "on";
}

export function useEquipmentSpecsReadHeaders(): EquipmentSpecsReadHeaders {
  const enabled = useEquipmentSpecsRolloutEnabled();

  return useMemo(
    () =>
      enabled ? { [EQUIPMENT_SPECS_READS_HEADER_NAME]: String(true) } : {},
    [enabled]
  );
}

export function useEquipmentSpecsWriteHeaders(): EquipmentSpecsWriteHeaders {
  const enabled = useEquipmentSpecsRolloutEnabled();

  return useMemo(
    () =>
      enabled
        ? {
            [EQUIPMENT_SPECS_READS_HEADER_NAME]: String(true),
            [EQUIPMENT_SPECS_WRITES_HEADER_NAME]: String(true),
          }
        : {},
    [enabled]
  );
}
